const styles = theme => ({
  infoSection: {
    width: 'calc(50% - 12px)'
  },
  summaryTitle: {
    marginBottom: theme.spacing.unit * 3
  },
  summaryDetails: {
    display: 'flex',
    marginBottom: theme.spacing.unit * 3,
    '& > div': {
      flex: 1
    }
  },
  summaryDetailsSection: {
    marginBottom: theme.spacing.unit * 3,
    '&:last-child': {
      marginBottom: 0
    }
  }
});

export default styles;
